var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 57,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 11,
    r: 10,
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 40.455c0-2.293.44-4.562 1.294-6.68a17.493 17.493 0 013.685-5.663 16.978 16.978 0 015.515-3.783A16.617 16.617 0 0118 23c2.233 0 4.443.451 6.506 1.329a16.978 16.978 0 015.515 3.783 17.494 17.494 0 013.685 5.663A17.861 17.861 0 0135 40.455V46H1v-5.545z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31.55L37.728 25 50 31.55c0 6.193-.204 12.288-2.271 17.11-1.722 4.016-9.092 7.34-10 7.34-.91 0-8.124-3.059-10.002-7.34C25.53 43.65 25.001 36.965 25 31.55z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40.5l3.5 4 6.5-8M37.728 25L25 31.55c.001 5.415.53 12.1 2.727 17.11C29.605 52.941 36.82 56 37.728 56c.91 0 8.279-3.324 10-7.34C49.797 43.838 50 37.743 50 31.55L37.728 25z",
    stroke: "#02B710",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgVerifSuccess;